import Link from 'next/link';

import { Icons } from 'app/constants/icons';
import { PAGES } from 'app/constants/pages';

export const LogoLink = () => {
  return (
    <Link href={PAGES.HOME} className="text-white light:text-neutral-800">
      <Icons.logoTestnet
        className="w-[86px] mobile:hidden"
        aria-label="Elys Network Logo"
      />

      <Icons.mobileLogo
        className="hidden w-5 mobile:flex"
        aria-label="Elys Network Logo"
      />
    </Link>
  );
};
